
<script>

    import Modal from 'svelte-simple-modal';
    import ModalContent from './miniComponents/ModalContent.svelte'

    import DiscoveryForm from './miniComponents/discoveryForm.svelte'
    import ClientNavBar from "./miniComponents/ClientNavBar.svelte";

    const backendUrl = '__backendUrl__';


    let search = '';





    // const showSurprise = () => {
    //     open(Surprise, { message: "It's a modal!" });
    // };

	let cats = [
		// { id: 'J---aiyznGQx', links:{website:'google.com',facebook:'reddit.com'}, wantsTocollaberate:true, tags:['love','instagood','me','tbt','cute','follow','followme','photooftheday'], name: 'Keyboard Cat' , description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`},
		// { id: 'z_AbfPXTKmsc', links:{}, tags:['love','photooftheday'], name: 'Maru', description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.` },
        // { id: 'OUtn3pvWmpgc', links:{}, tags:['love','instagood','follow','followme','photooftheday'], name: 'Henri The Existential Cat', description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.` },
        // { id: 'J---aiyznGQb', links:{}, tags:['love','instagood','me','tbt','cute','follow','followme','photooftheday'], name: 'Keyboard Cat' , description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`},
		// { id: 'z_AsbffdgPXTKms', links:{}, tags:['love','instagood','me','tbt','cute'], name: 'Maru', description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.` },
        // { id: 'OUtn3pvWfdmpg', links:{}, tags:['follow','followme','photooftheday'], name: 'Henri The Existential Cat', description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.` },
        // { id: 'J---aif4yznGQ', links:{}, tags:['love','instagood','cute','follow','followme'], name: 'Keyboard Cat' , description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`},
		// { id: 'z_Abf45PXTKms', links:{}, tags:['love','instagood','me','photooftheday'], name: 'Maru', description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.` },
		// { id: 'OUtn3435pvWmpg', links:{}, tags:['tbt','cute','follow','followme','photooftheday'],  name: 'Henri The Existential Cat', description:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.` }
    ];

    //$: search, filteredList = cats.filter((word) => {word.name.toLowerCase().includes(search.toLowerCase() ) || word.tags.includes(search)}); //cats.filter(word => word.contains(search) );
    let allTags = []
    let allUniqueTags = []

    $: search, filteredList = cats.filter((word) => { return word.name.toLowerCase().includes(search.toLowerCase() ) ||  word.tags.includes(search)});

   

    $: allTags = cats.reduce((acc, profile)=>{
         return acc.concat(profile.tags)
         },[])

    $: allUniqueTags = [...new Set(allTags)]

    fetch( backendUrl + '/public/clientProfile', {
        method: 'GET', // or 'PUT'
    }).then(response => {
        return response.json();
      }).then((res)=>{
    // window.location.href = "/products_new";
        console.log('res', res)
        cats = res
        console.log('sent', cats)
        console.log(res)
    })




    function stringToHslColorComp(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

    var h = hash % 360;


    var h2 = (h - 40)
    h2 = h2 < 0 ? h2 + 360 : h2

    return {
        colour1:' hsl(' + h + ', 80%, 50%)',
        colour2: 'hsl(' + h2 + ', 80%, 50%)'
    }
  }

     


    let filteredList = cats;

    let active = {

    }

    let formMode = false;



    let makeActive = (id)=>{
        console.log(id)
        if(id && id.id){
            active = cats.find(element => element.id == id.id);
        }else{
            active = {}
        }
    }

    
    let messageMakeActive = (event)=>{
        console.log(event)
        makeActive(event.detail)
    }
    

</script>


<ClientNavBar />
<div class="list-background">
    <!-- <div class="nav">Z</div> -->

    <div on:click|self={()=>{formMode = false}} class="svelte-modal {formMode ? 'on':'' }">
        <DiscoveryForm/>
    </div>

    <div on:click|self={()=>{makeActive()}} class="svelte-modal {active.id ? 'on':'' }">
        {#if active.id}

        <div class="modal-frame">
        {#if active.collaborate}
        <div class='info'>
            <div class='icon'><i class="fas fa-star"></i>Looking for live Buddy</div>
        </div>
        {/if }
        <div on:click={()=>{makeActive()}} class='close'>×</div>
           <div class="profile__image" style="background-image: url('{active.image}'); background-size: cover;"></div>
           <div class='links'>
            <ul class='social-list'>
            {#if active.links && active.links.facebook}
                <li>
                    <a target="_blank" href={active.links.facebook}><i class="fab fa-facebook"></i></a>
                </li>
            {/if}

            {#if active.links && active.links.instaId}
                <li>
                    <a target="_blank" href="https://www.instagram.com/{active.links.instaId}"><i class="fab fa-instagram"></i></a>
                </li>
            {/if}

            {#if active.links && active.links.siteUrl}
                <li>
                    <a href={active.links.siteUrl}><i class="fas fa-link"></i></a>
                </li>
            {/if}

            
            {#if active.links && active.links.etsy}
                <li>
                    <a target="_blank" href={active.links.etsy}><i class="fab fa-etsy"></i></a>
                </li>
            {/if}


            </ul>
            <div class='active-tags'>
                {#each active.tags as tag, i}
                    <li on:click={()=>{search = tag}}  style="background: linear-gradient(90deg, {stringToHslColorComp (tag).colour1} 0%, {stringToHslColorComp(tag).colour2} 100%)" class='pill'>
                    {tag}
                    </li>
                {/each}
            </div>


           </div>
           <div class="profile__info">
                <h3>{active.name} </h3>
                <p class="profile__info__extra">{active.description}</p>
            </div>
            <!-- <div class="profile__stats">
                <p class="profile__stats__title">Type</p>
                <h5 class="profile__stats__info">Puppy</h5>
            </div>
            <div class="profile__stats">
                <p class="profile__stats__title">Size</p>
                <h5>Medium</h5>
            </div>
            <div class="profile__stats">
                <p class="profile__stats__title">Weight</p>
                <h5 class="profile__stats__info">45.85 lbs</h5>
            </div>
            <div class="profile__cta"><a class="button">Adopt Doggo!</a></div> -->
        </div>

        {/if}


    </div>

    <div class="list-page">
        <div class='menu-bar circle-wrapper'>
            <div class='circle c-1'>
            </div>
            <div class='circle c-2'>
            </div>
            <div class='circle c-3'>
            </div>
            <div class='circle c-4'>
            </div>
            <div class='circle c-5'>
            </div>
            <div class='logo'></div>
            <div class='title'><h1><i class="fas fa-store"></i> Discovery Space</h1></div>
        </div>
        <div class='list-wrapper'>
            <div class='search-bar'>
                <label> Search </label>
                <input placeholder="illustrations" bind:value={search}>

            </div>
            <ul class='tagz tag-search'>
                {#each allUniqueTags as tag, i}
                    <!-- <li on:click={()=>{search = tag}}  style="background: {stringToHslColorComp(tag)}" class='pill'> -->
                    <li on:click={()=>{search = tag}}  style="background: linear-gradient(90deg, {stringToHslColorComp (tag).colour1} 0%, {stringToHslColorComp(tag).colour2} 100%);" class='pill'>


                    
                        {tag}
                    </li>
                {/each}
            </ul>

            <div class="page-info">
                <!-- <div class='page-text'>This is a space where the creativity and diverse talent of all makers and small businesses can be celebrated and promoted.</div> -->
                <div class='page-text'><p>Explore and support talented independent businesses in our creator discovery space.
                Shop small, Shop special, Shop stories!
                </p>
                <p>
                If you are a small business, explore and connect with our community and try out our Live Buddy Finder to collaborate on your next live.
                </p>

            </div>
              
                <div class='button-group'>
                    <div class='button main' on:click={()=>{formMode = true}}>
                    Join the space
                    </div>
                    <a href="/streamList">
                        <div  class='button alt'>
                            I want to go live
                        </div>
                    </a>
                </div>
            </div>

            <div class="divider"></div>

            <ul class='profiles'>
                {#each filteredList as { id, name, description, tags, image }, i}
                <li class="profile" >
                    <div>
                        <ModalContent on:makeActive={messageMakeActive} image={image} id={id} name={name} description={description} />
                    </div>

                    <ul class='tagz'>
                        {#each tags as tag, i}
                            {#if i < 3}
                                <li on:click={()=>{search = tag}}  style="background: linear-gradient(90deg, {stringToHslColorComp (tag).colour1} 0%, {stringToHslColorComp(tag).colour2} 100%)" class='pill'>
                                    {tag}
                                </li>
                            {/if}
                            {#if i === 3}
                                <span on:click={()=>{makeActive({id})}}>...</span>
                            {/if}
                        {/each}
                    </ul>
                </li>
                {/each}
            </ul>
        </div>
    </div>

</div>



<style>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Karla&display=swap');

html {
  box-sizing: border-box;
   font-family: sans-serif;
}
*, *:before, *:after {
  box-sizing: inherit;
}

h1{
    text-align: center;
    font-family: 'Bebas Neue', Arial, Helvetica, sans-serif;

}
ul{
    padding: 0px;
}
.social-list i{
    padding: 5px;
    padding: 8px 19px;
    border-radius: 5px;
    color:black;
}
.title{
    position: relative;
    color: white;
}
.logo.title{
   background: url(https://styrkin.s3-eu-west-1.amazonaws.com/public/logo_2.png);
   background: url(https://styrkin.s3-eu-west-1.amazonaws.com/public/logo_2.png);
    background-size: contain;
    background-repeat: no-repeat;
}

.page-text{
    max-width:750px;
    font-family: 'Karla', sans-serif;

}

.links{
    grid-column: span 3;
    text-align: center;
}

.button{
    padding: .8rem 2rem;
    font-weight: 600;
    font-size: 1.15rem;
    border-radius:10px;
    text-align: center;
    cursor:pointer;
}

.page-info{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: sans-serif;
    font-size: 17px;
    padding: 0px 18px;
}

.button-group{
    margin: 20px;
}
@media(max-width: 400px){
        
    .button-group{
        margin: 11px;
    }

    
    .button{
        padding: .8rem 1rem;
        font-size: 1rem;
    }

}


.button.main{
    color: #fff;
    background-color: #DA177D;
    border-color: #7952b3;
    margin-right:3px;
    margin-right: 17px;
}

.button.alt{
    color: #1d1d1d;
    background-color: #fff;
    border-color: #3AFECA;
    border: #3AFECA solid 3px;
}

.socials{
    grid-column: span 3;
    justify-content: center;
}

ul.social-list{
    display: inline-flex;
    align-content: space-between;
    list-style: none;
    width: 100%;
    justify-content: center;
    
    margin-top: 8px;
    margin-bottom: 0px;
}

ul.social-list li{
    margin:0px 9px;
    font-size: 25px;
}

.divider{
    height: 4px;
    background: aquamarine;
    background-image: linear-gradient(-350deg, #602bb6, #dd1173);
}

.tag-search{
    text-align: center;
    margin-bottom:40px;
}

.search-bar{
    text-align: center;
    font-size: 21px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

}
.svelte-modal{
    display: none;
}



.search-bar input{
    font-size: 21px;
    padding: 3px 5px;
    border: none;
    border: #80808000 solid 0.5px;
    border-bottom: hotpink 2px solid;
    
    background: #9e9e9e26;
    margin-left:7px;
}

.search-bar label{
    --display: inline-flex;
}

.search-bar input:focus{
    border: #80808033 solid 0.5px;
    outline: none;
    border-bottom: turquoise 2px solid;
}

.button-group{
    display:inline-flex;
}

.list-wrapper{
    max-width: 900px;
    padding-top: 50px;
    margin: 0 auto;
    backdrop-filter: blur(3px);
    
}

:global(body){
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(271,748,361)'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23ebebeb'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='540' height='450' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.03'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E") !important;
}


ul.profiles {
    display:flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    justify-content:space-around;

}


.tagz{
    padding: 0px;
}

.profile{

    height: 410px;
    margin: 25px 10px;
    padding:0px;
flex-grow: 0;
flex-shrink: 0;
flex-basis: 240px;
    list-style: none;
    text-align: -webkit-center;
    border:solid 1px grey;
    border-radius:15px;
}

.pill {
  font-family: Arial, sans-seif;
  display: inline-flex;
  padding: 6px 11px;
  border-radius: 30px;
  background-color: #ef2f2f;
  color: white;
  align-items: center;
  margin: 1px 3px;
  text-shadow: 1px 1px 3px #383333a8;
  font-size: 12px;
  font-weight: 700;
  /* &.blue {
    background-color: dodgerblue;
  }
  &.purple {
    background-color: #9b0fff;
  }
  &:last-child:not(:first-child) {
    margin: 0 0 0 3px;
  }
  &:first-child:not(:last-child) {
    margin: 0 3px 0 0; */
  }

  .svelte-modal.on{
        position: fixed;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.66);
        align-items: center;
        min-width: 100%;
        height: 100%;
    }


  /* .modal-frame{
      background:pink;
      --max-width: 400px;
  } */

  .modal-frame {
    --min-width: 400px;
    max-width: 450px;
    max-height: 100vh;
    background:white;
    margin: auto;
    overflow: hidden;
    display: grid;
    grid: 280px auto auto/repeat(3, minmax(80px, 1fr));
    grid-gap: 10px;
    overflow: auto;
    margin: 5px;
    font-family: sans-serif;
    padding-bottom: 13px;
    overflow-x: hidden;

}
.modal-frame {
    position: relative;
    box-shadow: 0 3px 15px rgba(51, 51, 51, 0.2);
    border-radius: 10px;
    transition: .2s ease;
}
.modal-frame .info{
    position: absolute;
    padding: 9px;
    font-size: 16px;
    background: #fdfdfdb8;
    text-shadow: 3px 3px 11px rgba(150, 150, 150, 1);
    backdrop-filter: blur(2px);
}

.modal-frame .info i{
   margin-right: 6px;
   color:#FF2EE6;
}

.profile{
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    cursor: pointer;
    background: #ffffff;

}

.profile:hover{
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}


.modal-frame .profile__image {
    grid-column: span 3;
    height: 281px;
    width: 450px;
    
}

.profile__info {
    grid-column: span 3;
    margin: 0px 25px 0;
}
.profile__stats {
    margin: 5px 25px;
}

img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.close {
    position: absolute;
    right: 9px;
    top: -9px;
    font-size: 60px;
    color: white;
    text-shadow: 1px 2px 4px #ff24e6;
}





/* #2c148c: #2c148c;
#36148c: #36148c;
#40148c: #40148c;
#4a148c: #4a148c;
$shade-5: #54148c;
$shade-6: #5e148c;
$shade-7: #68148c; */



.circle-wrapper{
  position:relative;
  overflow:hidden;
  background:#2c148c;
  height: 85px;
}

.circle{
  border-radius:760%;
  top: 0; left: 0; bottom: 0; right: 0;
  margin: auto;
  position:absolute;
  height:700px;
  width:100%;
  margin:auto;
  opacity:0.6;
  min-width: 80px;
  mix-blend-mode: lighten;
  mix-blend-mode: screen;
}


@keyframes c-3 {
  0%   {width:90%;}
  25%  {background-color: #2c148c;}
  50%  {background-color: #36148c;}
  100% {
    border-width:10%;
    width: 20%;
    background-color: #40148c;
  }
}

@keyframes c-4 {
  0%   {width:90%;}
  25%  {background-color: #2c148c;}
  50%  {background-color: #36148c;}
  100% {
    width: 70%;
    background-color: #40148c;
  }
}

/* The element to apply the animation to */
.c-3 {
  background-color: #4a148c;
  width:  90%;
  animation-name: c-3;
  animation-duration: 14s;
  border: solid #FF24E6;
  animation-direction: alternate ;
  animation-iteration-count: infinite;
}

.c-4 {
  background-color: #4a148c;
  width:  90%;
  animation-name: c-4;
  animation-duration: 10s;
  animation-direction: alternate ;
  animation-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);
  animation-iteration-count: infinite;
}

.c-5 {
  background-color: #4a148c;
  width:  90%;
  animation-name: c-4;
  animation-duration: 11s;
  opacity:0.2;
  animation-direction: alternate ;
  animation-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);
  animation-iteration-count: infinite;
}



.c-1 {
  background-color: #4a148c;
  animation-delay: 2s;
  width:  90%;
  animation-name: c-3;
  animation-duration: 14s;
  animation-direction: alternate ;
  animation-iteration-count: infinite;
}

.c-2{  animation-name: c-3;
  animation-duration: 18s;
  animation-direction: alternate ;
  animation-iteration-count: infinite;}

  

</style>